<script>
  import { getAuth, onAuthStateChanged, GoogleAuthProvider, FacebookAuthProvider, createUserWithEmailAndPassword, signInWithEmailAndPassword, signInWithRedirect, signInWithPopup, signInAnonymously, signOut } from 'firebase/auth'
  import { doc, collection, setDoc, getDoc, getFirestore, } from 'firebase/firestore'

  const auth = getAuth()
  const db = getFirestore()
  const usersCollection = collection(db, 'users')
  // Firebase user
  let user = null;
  export let busy = true;

  // expose property on the component that we can use
  // to choose if we want use popup or redirect
  export let useRedirect = false;
  // small mapper function
  const userMapper = claims => ({
    name: claims.name || '',
    email: claims.email || '',
    picture: claims.picture || '',
    provider: claims.firebase?.sign_in_provider || '',
  });

  export const loginAnonymously = () => 
    signInAnonymously(auth)

  export const loginWithEmailPassword = (email, password) =>
    signInWithEmailAndPassword(auth, email, password);

  export const registerWithEmailPassword = (email, password) =>
    createUserWithEmailAndPassword(auth, email, password);

  export const loginWithGoogle = () => {
    const provider = new GoogleAuthProvider().addScope('email');
    if (useRedirect) {
      return signInWithRedirect(auth, provider);
    } else {
      return signInWithPopup(auth, provider);
    }
  };
  export const loginWithFacebook = () => {
    const provider = new FacebookAuthProvider().addScope('email');
    if (useRedirect) {
      return signInWithRedirect(auth, provider);
    } else {
      return signInWithPopup(auth, provider);
    }
  };

  export const logout = () => signOut(auth);

  // will be fired every time auth state changes
  onAuthStateChanged(auth, async fireUser => {
    busy = false
    if (fireUser) {
      // in here you might want to do some further actions
      // such as loading more data, etc.

      // if you want to set custom claims such as roles on a user
      // this is how to get them because they will be present
      // on the token.claims object
      const token = await fireUser.getIdTokenResult();
      const setupUser = async (userId) => {
        const docRef = doc(db, 'users', userId)
        const docSnap = await getDoc(docRef)
        // pull the email from provider data
        token.claims.email = token.claims.email || fireUser.providerData[0]?.email || ''
        if(!docSnap.exists()) {
          const resp = await setDoc(doc(usersCollection, userId), userMapper(token.claims))
        } else {

        }
      }
      setupUser(token.claims.user_id)
      user = userMapper(token.claims);
    } else {
      user = null;
    }
  });
  // reactive helper variable
  $: loggedIn = user !== null;
</script>

<!-- we will expose all required methods and properties on our slot -->
<div>
  <slot {user} {loggedIn} {loginWithGoogle} {loginWithEmailPassword} {loginWithFacebook} {loginAnonymously} {registerWithEmailPassword} {logout} />
</div>